import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { DiscoveryPage } from './pages/DiscoveryPage';
import { AskPage } from './pages/AskPage';
import { DepositionPage } from './pages/DepositionPage';
import { CasesPage } from './pages/CasesPage';
export function App() {
  const [selectedCaseId, setSelectedCaseId] = useState<string | null>(null);
  const [activePage, setActivePage] = useState<'discovery' | 'ask' | 'deposition'>('discovery');
  const handleSelectCase = (caseId: string) => {
    setSelectedCaseId(caseId);
    setActivePage('discovery');
  };
  const handleBackToCases = () => {
    setSelectedCaseId(null);
  };
  if (!selectedCaseId) {
    return <CasesPage onSelectCase={handleSelectCase} data-id="element-0" />;
  }
  return <div className="flex h-screen w-screen overflow-hidden bg-navy text-text-primary font-sans selection:bg-accent-amber/30 selection:text-white" data-id="element-1">
      <Sidebar activePage={activePage} setActivePage={setActivePage} onBackToCases={handleBackToCases} data-id="element-2" />
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden relative" data-id="element-3">
        {activePage === 'discovery' && <DiscoveryPage data-id="element-4" />}
        {activePage === 'ask' && <AskPage data-id="element-5" />}
        {activePage === 'deposition' && <DepositionPage data-id="element-6" />}
      </main>
    </div>;
}